// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbs_a bhs_g"};